// Formats a raw phone string as nnn-nnn-nnnn for display.
// Strips non-digits and drops a leading US country code (1) when present.
// Falls back to the original string if it isn't a 10-digit number.
export const formatPhone = (raw?: string): string => {
  if (!raw) return raw ?? "";

  const digits = raw.replace(/\D/g, "");

  let core = digits;
  if (core.length === 11 && core.startsWith("1")) {
    core = core.slice(1);
  }

  if (core.length === 10) {
    return `${core.slice(0, 3)}-${core.slice(3, 6)}-${core.slice(6)}`;
  }

  return raw;
};
